/**
 * Role helpers.
 *
 * The backend is the real security boundary — every financial route carries
 * `requireAdmin` — so these helpers only decide what the UI *renders*. A staff
 * login never sees a door it cannot open, and a hidden button is never the only
 * thing standing between staff and another member's money.
 *
 * The API normalises roles to "admin" | "staff". Anything else, including a
 * missing role, is treated as the least-privileged role, so an unexpected value
 * can never widen access.
 */
export const ROLE_ADMIN = "admin";
export const ROLE_STAFF = "staff";

export const normalizeRole = (user) =>
  user?.role === ROLE_ADMIN ? ROLE_ADMIN : ROLE_STAFF;

export const isAdmin = (user) => normalizeRole(user) === ROLE_ADMIN;

export const isStaff = (user) => normalizeRole(user) === ROLE_STAFF;

/**
 * Money — salon revenue, gross profit, cash-out expenses and salary/payout
 * maths — is admin-only. Staff see their own performance and their own earned
 * commission, never the business's financials.
 */
export const canViewFinancials = (user) => isAdmin(user);

/** True when `user`'s normalised role is in the allow-list. */
export const hasRole = (user, roles = []) => roles.includes(normalizeRole(user));

export default { normalizeRole, isAdmin, isStaff, canViewFinancials, hasRole };
